import { useState } from "react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import { Check, Copy } from "lucide-react";
import { copyText } from "@/lib/docs";

const ALIASES = { dotenv: "bash", sh: "bash", shell: "bash", text: "text", txt: "text" };

export const CodeBlock = ({ code, language, showLineNumbers = false, testId = "code-block", bare = false }) => {
  const [copied, setCopied] = useState(false);
  const lang = ALIASES[language] || language || "text";

  const copy = async () => {
    await copyText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div data-testid={testId} className={`code-block overflow-hidden rounded-lg border border-code-border bg-code ${bare ? "" : "my-5"}`}>
      <div className="flex items-center justify-between border-b border-code-border px-4 py-1.5">
        <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-400">{lang}</span>
        <button
          type="button"
          onClick={copy}
          data-testid={`${testId}-copy-btn`}
          className="inline-flex items-center gap-1.5 rounded px-2 py-1 font-mono text-[11px] text-slate-400 transition-colors hover:bg-white/5 hover:text-slate-100"
        >
          {copied ? <Check className="h-3.5 w-3.5 text-ok" /> : <Copy className="h-3.5 w-3.5" />}
          {copied ? "Kopirano" : "Kopiraj"}
        </button>
      </div>
      <SyntaxHighlighter
        language={lang}
        style={oneDark}
        showLineNumbers={showLineNumbers}
        lineNumberStyle={{ minWidth: "3em", color: "#4b5563", userSelect: "none" }}
        customStyle={{ margin: 0, background: "transparent", padding: "1rem 1.25rem", fontSize: "0.8125rem", lineHeight: 1.65 }}
        codeTagProps={{ style: { fontFamily: "var(--font-mono)", background: "transparent" } }}
      >
        {code.replace(/\n$/, "")}
      </SyntaxHighlighter>
    </div>
  );
};
